export const FIELD_TYPES = [
  { text: 'String', value: 'string' },
  { text: 'Text', value: 'text' },
  { text: 'Integer', value: 'integer' },
  { text: 'Number', value: 'number' },
  { text: 'Boolean', value: 'boolean' },
  { text: 'Array of Integers', value: 'array:int' },
  { text: 'Array of Strings', value: 'array:string' },
  { text: 'Image', value: 'image' },
  { text: 'File', value: 'file' },
  { text: 'Object', value: 'object' },
  { text: 'Array of Objects', value: 'array' },
  { text: 'Fragment ($ref)', value: 'fragment' },
]

export const SOURCE_TYPES = [
  { text: 'None', value: null },
  { text: 'CMS Items', value: 'item' },
  { text: 'External API', value: 'api' },
  { text: 'Static List', value: 'static' },
]

export const INDEXABLE_TYPES = ['string', 'text', 'integer', 'number', 'boolean', 'array:string', 'array:int']
export const TRANSLATABLE_TYPES = ['string', 'text']
export const SOURCE_TYPES_ALLOWED = ['string', 'integer', 'number', 'array:string', 'array:int']
export const NESTED_TYPES = ['object', 'array']
export const ENUM_TYPES = ['string', 'integer', 'number', 'array:string', 'array:int']

// Display widget for array:* fields (how the value is rendered in the item form)
export const WIDGET_OPTIONS = [
  { text: 'Chips (free input)', value: 'chips' },
  { text: 'Single select', value: 'single' },
  { text: 'Multi select', value: 'multi' },
]
export const WIDGET_TYPES = ['array:string', 'array:int']

export function createDefaultField(fieldset) {
  const field = {
    key: '',
    label: '',
    type: 'string',
  }
  if (fieldset) {
    field.fieldset = fieldset
  }
  return field
}

export function createDefaultFieldset() {
  return {
    key: '',
    label: '',
    expanded: true,
  }
}
